import { matchPath } from 'react-router';
import { URL_PATH } from './route-path';

/**
 * プロジェクト詳細ページへのパスかを判定し、match 情報を返す
 *   /rs/project/:projectId
 *
 * @param pathname location.pathname など
 * @returns matchPath の結果 (一致しない場合は null)
 */
export const matchProjectDetailPath = (pathname: string) => {
  return matchPath({ path: `/${URL_PATH.projectDetail}` }, pathname);
};
